import { BaseInputField } from 'components/Input/InputField/BaseInputField';
import { BaseInputFieldProps } from 'components/Input/InputField/BaseInputField/types';
import { formatPhoneNumber } from 'utils/phone';

export const PhoneNumberField = (props: BaseInputFieldProps) => {
  return (
    <BaseInputField
      type='tel'
      placeholder='Phone number'
      label='Phone Number'
      onInput={(e: React.FormEvent) => {
        (e.target as HTMLInputElement).value = formatPhoneNumber(
          (e.target as HTMLInputElement).value,
        );
      }}
      {...props}
    />
  );
};

export default PhoneNumberField;
